import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ManageScheduling } from "@hedgefund/shared";
import { manageScheduleAction, updateScheduleAction } from "./actions";

const ManageSchedule = () => {
  const dispatch = useDispatch();
  const { loading, schedule } = useSelector((state) => state.manage);
  const updateSchedule = (data) => {
    dispatch(updateScheduleAction(data));
  };

  useEffect(() => {
    dispatch(manageScheduleAction());
  }, [dispatch]);

  return (
    <ManageScheduling
      loading={loading}
      schedule={schedule.schedule}
      updateSchedule={updateSchedule}
    />
  );
};

export default ManageSchedule;
